import { Tabs } from "@components/tabs-nav/TabNav.types";

export const SystemProsTabs: Tabs = {
  Operations: {
    Banner: { id: "ops-banner", name: "Banner" }
  },
  SiteIntegration: {
    DeploymentManagement: {
      id: "pros-deployment-management",
      name: "Deployment Management"
    }
  }
};
